(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["csp-load-more"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('csp-load-more')) {
    customElements.define(
      'csp-load-more',
      class CspLoadMore extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-csp-load-more]');
          this.button?.addEventListener('click', () => this.loadMore());
        }

        async loadMore() {
          if (!this.button) return;
          const pageSize = Number(this.button.dataset.pageSize || 24);
          const currentPage = Number(this.button.dataset.page || 1);
          const nextPage = currentPage + 1;
          // Always page from the collection URL. Shopify's paginate.next link
          // inside a section-render response is unreliable after the first fetch.
          const url = new URL(window.location.href);
          url.searchParams.set('page', String(nextPage));
          url.searchParams.set('section_id', this.button.dataset.sectionId);
          this.button.disabled = true;
          try {
            const response = await fetch(url.toString());
            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const incoming = doc.querySelector('#product-grid');
            const grid = document.querySelector('#product-grid');
            if (!incoming || !grid) {
              this.button.disabled = false;
              return;
            }
            const items = [...incoming.querySelectorAll(':scope > li')];
            if (!items.length) {
              this.remove();
              return;
            }
            items.forEach((item) => grid.appendChild(item));
            this.button.dataset.page = String(nextPage);
            if (items.length < pageSize) {
              this.remove();
              return;
            }
            this.button.disabled = false;
          } catch (error) {
            this.button.disabled = false;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
